import { React, useState, useRef, useEffect } from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";
import IconButton from "@mui/material/IconButton";
import AssignmentIcon from "@mui/icons-material/Assignment";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import Button from "@mui/material/Button";
import { ToastContainer, toast } from "react-toastify";
import { Dropdown } from "semantic-ui-react";
import Tooltip from "@mui/material/Tooltip";
import { Stack } from "@mui/material";
import InputBase from "@mui/material/InputBase";
import Paper from "@mui/material/Paper";
import SearchIcon from "@mui/icons-material/Search";
import Papa from "papaparse";
import MDBadge from "components/MDBadge";
import MDTypography from "components/MDTypography";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import DescriptionIcon from "@mui/icons-material/Description";
import VisibilityIcon from "@mui/icons-material/Visibility";
const BASE_URL = process.env.REACT_APP_BASE_URL;
const token = sessionStorage.getItem("token");

const ExportApplication = () => {
  //variables declarations
  const theme = useTheme();
  const [formData, setFormData] = useState({
    campaign: null,
    first_preference: null,
    second_preference: null,
    third_preference: null,
    admission_type: null,
    admission_category: null,
    admission_subcategory: null,
    title: null,
    first_name: null,
    last_name: null,
    applicant_image: null,
    father_name: null,
    gender: null,
    dob: null,
    marital_status: null,
    blood_group: null,
    religion: null,
    p_house_no: null,
    p_street_no: null,
    p_city: null,
    p_country: null,
    p_postal_code: null,
    p_province: null,
    c_house_no: null,
    c_street_no: null,
    c_city: null,
    c_country: null,
    c_postal_code: null,
    c_province: null,
    emergency_contact_name: null,
    emergency_contact_no: null,
    applicant_cnic: null,
    applicant_cnic_image: null,
    father_cnic: null,
    father_cnic_image: null,
    city_of_birth: null,
    country_of_permanent_residence: null,
    nationality: null,
    other_nationality: null,
    research_area: null,
    research_year: null,
    disability: null,
    obtained_test_score: null,
    obtained_interview_score: null,
    voucher_no: null,
    form_no: null,
    card_number: null,
    payment_method: null,
    is_paid: null,
    academics: null,
    references: null,
    work_experiences: null,
  });
  const [apiLink, setApiLink] = useState("");
  const [mainVariable, setMainVariable] = useState("");
  const [auth, setAuth] = useState("no-auth");
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [bearerToken, setBearerToken] = useState("");
  const fields = Object.keys(formData);
  //handle functions
  const handleChange = (e) => {
    const { name, value } = e.target;
    console.log(name, value);
    setFormData({ ...formData, [name]: value });
  };
  const handleSave = () => {
    console.log("formData", formData);
    let data = formData;
    data["api_link"] = apiLink;
    data["main_variable"] = mainVariable;
    data["auth"] = auth;
    data["username"] = userName;
    data["password"] = password;
    data["bearer_token"] = bearerToken;
    console.log("Postdata",data);
  };
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <ToastContainer />
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Card>
            <MDBox p={3}>
              <MDTypography variant="h6" gutterBottom>
                Export Applications Settings
              </MDTypography>
              <MDBox display="flex" justifyContent="flex-end">
                <Button
                  variant="outlined"
                  color="primary"
                  size="small"
                  endIcon={<AssignmentIcon  sx={{
                    width: "22px",
                    height: "22px",
                    marginLeft: "22px",
                  }} />}
                  onClick={handleSave}
                  style={{
                    color: "black",
                    borderColor: "black",
                    fontWeight: 500,
                    fontSize: "16px",
                  }}
                >
                  Save
                </Button>
              </MDBox>
            </MDBox>
            <MDBox p={3}>
              <div className="row">
                <div className="col-md-12">
                  <h6 className="text-danger">
                    Note: Api Should have POST route
                  </h6>
                </div>
                {fields.map((field) => (
                  <div key={field} className="col-md-3 mt-2">
                    <h5>{field}</h5>
                    <input
                      type="text"
                      className="form-control"
                      placeholder={`Enter You Variable Name`}
                      name={field}
                      value={formData[field] || ""}
                      onChange={(e) => handleChange(e)}
                    />
                  </div>
                ))}{" "}
                <div className="col-md-4 mt-2">
                  <h5>Api Link</h5>
                  <input
                    type="text"
                    className="form-control"
                    placeholder={`Enter Your Api Link`}
                    name="api_link"
                    value={apiLink || ""}
                    onChange={(e) => setApiLink(e.target.value)}
                  />
                </div>
                <div className="col-md-4 mt-2">
                  <h5>Auth</h5>
                  <select
                    className="form-control"
                    name="auth"
                    value={auth}
                    onChange={(e) => setAuth(e.target.value)}
                  >
                    <option value="no-auth">No Auth</option>
                    <option value="basic-auth">Basic Auth</option>
                    <option value="token-auth">Token Auth</option>
                  </select>
                </div>
                {auth === "basic-auth" && (
                  <>
                    <div className="col-md-4 mt-3">
                      <h5>Username</h5>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter Your Username"
                        value={userName}
                        onChange={(e) => setUserName(e.target.value)}
                      />
                    </div>
                    <div className="col-md-4 mt-3">
                      <h5>Password</h5>
                      <input
                        type="password"
                        className="form-control"
                        placeholder="Enter Your Password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                      />
                    </div>
                  </>
                )}
                {auth === "token-auth" && (
                  <div className="col-md-6 mt-3">
                    <h5>Bearer Token</h5>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Your Token"
                      value={bearerToken}
                      onChange={(e) => setBearerToken(e.target.value)}
                    />
                  </div>
                )}
                <div className="col-md-4 mt-3">
                  <h5>Main Variable</h5>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Your Main Variable Name"
                    value={mainVariable}
                    onChange={(e) => setMainVariable(e.target.value)}
                  />
                </div>
                <div className="col-md-8"></div>
              </div>
            </MDBox>
          </Card>
        </Grid>
      </Grid>
    </DashboardLayout>
  );
};

export default ExportApplication;
